<template>
    <div class="formSetting">
        <el-collapse v-model="activeNames" accordion>
            <el-collapse-item title="内容" name="1">
                <div style="padding: 20px;">
                    <el-collapse class="form_item" accordion>
                        <el-collapse-item v-for="(item, index) in data.swiper.list" :key="index" :name="index">
                            <template slot="title">
                                <div class="con_title">
                                    <span>{{ item.title }}</span>
                                    <el-button size="small" icon="el-icon-close" type="info" plain
                                        @click="handleRemove(index, $event)">
                                    </el-button>
                                </div>
                            </template>
                            <ul class="settingUl">
                                <li>
                                    <span>图标</span>
                                    <el-radio-group v-model="item.icon" size="mini">
                                        <el-radio-button label="font-icon-gg1"><i
                                                class="font-icon font-icon-gg1"></i></el-radio-button>
                                        <el-radio-button label="font-icon-gg2"><i
                                                class="font-icon font-icon-gg2"></i></el-radio-button>
                                        <el-radio-button label="font-icon-gg3"><i
                                                class="font-icon font-icon-gg3"></i></el-radio-button>
                                        <el-radio-button label="font-icon-gg4"><i
                                                class="font-icon font-icon-gg4"></i></el-radio-button>
                                    </el-radio-group>
                                </li>
                                <li>
                                    <span>标题</span>
                                    <el-input style="width: 300px;" v-model="item.title" placeholder=""
                                        size="small"></el-input>
                                </li>
                                <li>
                                    <span>链接</span>
                                    <el-dropdown @command="handleLinkItem">
                                        <span class="el-dropdown-link">
                                            {{ item.link }}<i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-for="(link, idx) in data.linkList" :key="idx"
                                            :command="`${link.title}#${link.page}?${index}`">
                                                {{ link.title }}
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </li>
                            </ul>
                        </el-collapse-item>
                    </el-collapse>
                    <el-button type="primary" style="width: 100%;" size="small" @click="handleFormAdd">添加公告</el-button>
                </div>
            </el-collapse-item>
            <el-collapse-item title="内容样式" name="3">
                <ul class="settingUl">
                    <li>
                        <span>滚动方向</span>
                        <el-radio-group v-model="data.align" size="mini">
                            <el-radio-button label="向上"></el-radio-button>
                            <el-radio-button label="向左"></el-radio-button>
                        </el-radio-group>
                    </li>
                    <li>
                        <span>文字颜色</span>
                        <el-color-picker v-model="data.color"></el-color-picker>
                    </li>
                </ul>
            </el-collapse-item>
            <el-collapse-item title="组件样式" name="4">
                <comSetting :infoItme="data.infoItme" />
            </el-collapse-item>
        </el-collapse>
    </div>
</template>
<script>

import comSetting from '../comSetting'
export default {
  name: 'gonggaoSetting',
  components: { comSetting },
  props: {
    data: Object
  },
  data () {
    return {
      activeNames: ['1'],
      btnVal: '',
      value1: true,
      msgValue: false
    }
  },
  methods: {
    handleRemove (index, event) {
      event.stopPropagation()
      this.data.swiper.list.splice(index, 1)
    },

    handleFormAdd () {
      this.data.swiper.list.push({
        title: '请输入公告内容！',
        icon: 'font-icon-gg1',
        link: ''
      })
    },
    handleLinkItem (command) {
      const idx = command.indexOf('?')
      const idx1 = command.indexOf('#')
      var before = command.substring(0, idx)
      var after = command.substring(idx + 1)
      const pagetit = before.substring(0, idx1)
      const page = before.substring(idx1 + 1)

      this.data.swiper.list[Number(after)].link = pagetit
      this.data.swiper.list[Number(after)].page = page
    }
  },
  mounted () {
    console.log(this.data)
  }
}
</script>

<style scoped>
.formSetting {
    padding: 10px;
}

.form_item {
    border: none;
}

.form_item .el-collapse-item {
    border: 1px solid #e1e4eb;
    margin-bottom: 15px;
    border-radius: 4px;
}

/deep/ .form_item .el-collapse-item .el-collapse-item__header {
    border-bottom-color: transparent;
    height: 32px;
    font-size: 12px;
    color: #516280;
    line-height: 32px;
    background-color: #f7f9fb;
    margin: 0;
    padding-left: 10px;
}

/deep/ .form_item .el-collapse-item__content {
    padding: 15px;
}

/deep/ .form_item .el-collapse-item__wrap {
    border: none;
}

/deep/ .form_item .el-collapse-item__arrow {
    display: none;
}

.form_item .con_title {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.form_item .con_title .el-button {
    border: none;
    background: #f7f9fb;
    color: #909399;
    border-left: 1px solid #e1e4eb;
}

.xuanxDel {
    font-size: 18px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/gonggao/gonggaoSetting.vue